<script>
export default {
    props: {
     title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
 

    categories: {
      type: Array,
      default: () => []
    },

    data: {
      type: Array,
      default: () => []
    },


  },
  data() {
    return {
      
    
          series: [{
            name: this.name,
            data: this.data
          }, 
         ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'area',
              zoom: {
              enabled: true,
              autoScaleYaxis: true,
              
            }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth'
            },
            xaxis: {
                categories: this.categories,

            },
            yaxis: {
              title: {
                text: ''
              },
              labels: {
              formatter: function (value) {
                  return Math.round(value); 
              }
          }
        
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return   val +" Articles";
                }
              }
            },

            title: {
            text: this.title, 
            align: 'left',
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#333'
          }
        },
          },
        
    };
  },
};
</script>

<template>
  <div id="chart">
        <apexchart type="area" height="350" :options="chartOptions" :series="series"></apexchart>
      </div>
</template>
